import * as Yup from "yup";

const schema = Yup.object({
  id: Yup.string(),
  Name: Yup.string().required("Name is required"),
  FullURL: Yup.string()
    .url("FullURL must be a valid URL")
    .required("FullURL is required"), // Fully qualified URL
  DeltaURL: Yup.string()
    .url("DeltaURL must be a valid URL")
    .required("DeltaURL is required"), // Fully qualified URL
  Salt: Yup.string().optional(), // String, not required
});

export default schema;
